/* eslint-disable react/self-closing-comp */
// @ts-ignore
import React from "react";

import { SvgContainer } from "./svg-container";

export const DollarIcon = () => {
    return (
        <SvgContainer>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                preserveAspectRatio="xMinYMin meet"
                viewBox="0 0 36 36"
                aria-hidden="true"
            >
                <path
                    fill="#ffffff"
                    fillRule="evenodd"
                    d="M23,12.65a1.23,1.23,0,0,0,2.45-.06V11.15a7.45,7.45,0,0,0-6.22-7.22V1.17a1.23,1.23,0,0,0-2.46.06v2.7a7.43,7.43,0,0,0-6.22,7.34v.63A7.44,7.44,0,0,0,18,19.23h.09a5,5,0,0,1,4.91,5v.59a5,5,0,0,1-10-.09V23.35a1.23,1.23,0,0,0-2.45.06v1.44a7.45,7.45,0,0,0,6.22,7.22v2.76a1.23,1.23,0,0,0,2.46-.06v-2.7a7.43,7.43,0,0,0,6.22-7.34V24.1A7.44,7.44,0,0,0,18,16.77h-.09a5,5,0,0,1-4.91-5v-.59a5,5,0,0,1,10,.09v1.38Z"
                ></path>
            </svg>
        </SvgContainer>
    );
};
